<div class="container-fluid" [ngClass]="containerClass">
    <!-- Top Section -->
    @if (showScore || showFinancials) {
        <div class="card border-0 shadow-sm mb-4">
            <div class="card-body">
                <div class="d-sm-flex justify-content-between align-items-center mb-4">
                    <div>
                        @if (showScore) {
                            <h4 class="mb-0 text-secondary">{{ title }}</h4>
                        }
                    </div>
                    <div class="d-flex align-items-end mt-3 mt-md-0">
                        <dx-date-range-box
                            [multiView]="false"
                            [showClearButton]="true"
                            [(value)]="dateRangeFilterValue"
                            (onValueChanged)="onDateRangeChanged($event)"
                            stylingMode="filled"
                        >
                        </dx-date-range-box>
                        @if (showScore && exportData) {
                            <dx-button stylingMode="text" class="ms-3" icon="export" (onClick)="onExport()"></dx-button>
                        }
                    </div>
                </div>
                @if (showScore) {
                    <div class="row align-items-center mb-4">
                        <!-- Main Score Chart -->
                        <div class="col-sm-8 text-center position-relative">
                            <app-doughnut-chart
                                [from]="fromDate"
                                [to]="toDate"
                                [centerText]="centerText"
                                (loaded)="onMainChartLoaded($event)"
                                [employeeId]="employeeId"
                                [loadData]="loadScoreData"
                                [palette]="palette"
                                [noDataExclude]="noDataExclude"
                                [scoreCountsAsData]="scoreCountsAsData"
                                [formatMode]="formatMode"
                                [useCapitalCaseFormatting]="useCapitalCaseFormatting"
                            ></app-doughnut-chart>
                        </div>

                        <!-- Details Table -->
                        <div class="col-sm-4 col-xl-3 offset-xl-1">
                            <div class="table-responsive rounded-1 border border-1">
                                <table class="table table-borderless mb-0">
                                    <thead class="bg-light text-muted small text-uppercase">
                                    <tr class="table-light">
                                        <th>Type</th>
                                        <th>Instances</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        @for (detail of scoreData; track detail) {
                                            <tr class="border-top">
                                                <td class="text-muted">{{ useCapitalCaseFormatting ? (detail.argument | capitalCase) : detail.argument }}</td>
                                                <td class="text-muted">{{ detail.value | number:'1.0-2' }}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <ng-content select="[intermediate-content]"></ng-content>

                    <!-- Breakdown Charts -->
                    @if(showBreakdownCharts){
                        <div class="card border-0">
                            <div class="card-body text-center">
                                <div class="d-flex justify-content-center align-items-center flex-wrap gap-4">
                                    @for (shift of [ShiftType.Day, ShiftType.Afternoons, ShiftType.WeekendDays, ShiftType.WeekendNights]; track shift) {
                                        <div [ngClass]="showChart(shift) ? 'd-block' : 'd-none'">
                                            <h5 class="text-muted mb-3">{{ shift | capitalCase }}</h5>
                                            <div class="position-relative d-inline-block">
                                                <app-doughnut-chart
                                                    [from]="fromDate"
                                                    [to]="toDate"
                                                    [shiftType]="shift"
                                                    [centerText]="centerText"
                                                    [responsive]="false"
                                                    (loaded)="onShiftChartLoaded($event, shift)"
                                                    [employeeId]="employeeId"
                                                    [loadData]="loadScoreData"
                                                    [palette]="palette"
                                                    [formatMode]="formatMode"
                                                    [useCapitalCaseFormatting]="useCapitalCaseFormatting"
                                                ></app-doughnut-chart>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                }

                 <ng-content select="[bottom-content]"></ng-content>
            </div>
        </div>
    }

    <!-- Trending Section -->
    @if (showTrending) {
        <div class="card border-0 shadow-sm">
            <div class="card-body">
                <div class="d-sm-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h4 class="mb-0 text-secondary">{{ trendingTitle }}</h4>
                    </div>
                    <div class="d-flex align-items-end mt-3 mt-md-0">
                        <dx-select-box
                            [items]="trendingFilterOptions"
                            [(value)]="trendingFilterValue"
                            valueExpr="value"
                            displayExpr="text"
                            stylingMode="filled"
                        >
                        </dx-select-box>
                    </div>
                </div>

                <div class="mb-5">
                    <app-trending
                        [aggregateType]="trendingFilterValue"
                        [employeeId]="employeeId"
                        [loadData]="loadTrendingData"
                        [formatMode]="formatMode"
                    ></app-trending>
                </div>
            </div>
        </div>
    }
</div>
